export const IconPlus = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_13970_377)">
    <path fillRule="evenodd" clipRule="evenodd" d="M11 19C11 19.55 11.45 20 12 20C12.55 20 13 19.55 13 19V13H19C19.55 13 20 12.55 20 12C20 11.45 19.55 11 19 11H13V5C13 4.45 12.55 4 12 4C11.45 4 11 4.45 11 5V11H5C4.45 11 4 11.45 4 12C4 12.55 4.45 13 5 13H11V19Z" fill="black"/>
    </g>
    <defs>
    <clipPath id="clip0_13970_377">
    <rect width="24" height="24" fill="white"/>
    </clipPath>
    </defs>
  </svg>
)

export const IconMinus = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_13970_453)">
    <path d="M5 12H19H5Z" fill="#212121"/>
    <path d="M5 12H19" stroke="#212121" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
    <clipPath id="clip0_13970_453">
    <rect width="24" height="24" fill="white"/>
    </clipPath>
  </defs>
  </svg>
)